<template>
  <section class="table">
    <div>
      <label class="switch-container">
        Visa alla tillgångar
        <span class="switch">
          <input
            type="checkbox"
            checked
            @change="toggle ? toggle = false : toggle = true"
          >
          <span class="slider round"></span>
        </span>
      </label>
    </div>

    <table class="table__container">
      <tr class="table__heading">
        <th
          :key="i"
          v-for="(heading, i) in headings"
          class="table__heading-text"
        >
          {{ heading }}
        </th>
      </tr>
      <tr
        :key="i"
        v-for="(item, i) in toggleItems"
        class="table__cell-container"
      >
        <td class="table__cell table--light">{{ item.asset }}</td>

        <td class="table__cell table--light">
          <TrafficLights class="table__traffic-lights" :rate="item.rate" />
        </td>

        <td
          class="table__cell table--light"
          :class="checkIfNA(item.fee)"
        >
          {{ item.fee }}
        </td>

        <td
          class="table__cell table--light"
          :class="[checkIfNA(item.fee), checkDev(item.development)]"
        >
          {{ item.development === '' ? 'N/A' : item.development }}
        </td>

        <!-- Start: Worth -->
        <td class="table__cell table--light" v-if="item.editable">
          <router-link to="/assets" class="table__cell-link">
            <span class="table__cell-link__icon" v-if="item.userAdded">
              <img class="table__cell-link__icon-img" :src="pencilSVG">
            </span>

            <span class="table__cell-link__fill-here table__cell-text" v-if="item.worth === ''">
              Inget angett
            </span>

            <span class="table__cell-text table__cell-text-editable" v-else> {{ item.worth }} </span>
          </router-link>
        </td>
        <td class="table__cell table--light" v-else>
          <span class="table__cell-text"> {{ item.worth }} </span>
        </td>
        <!-- End: Worth -->

        <!--<td class="table__cell table--light">
          <img class="table__info-img" :src="infoSVG">
        </td>-->
      </tr>

      <tr class="table__sum">
        <td class="table__cell">Summering</td>
        <td/> <!-- To give room for traffic lights -->
        <td class="table__cell">N/A</td>
        <td class="table__cell">N/A</td>
        <td class="table__cell">{{ sum }} KR</td>
         <!-- <td/> To give room for info-img -->
      </tr>
    </table>
  </section>
</template>

<script>
import TrafficLights from '../elements/TrafficLights'
import infoSVG from '../../assets/svg/info.svg'
import pencilSVG from '../../assets/svg/pencil.svg'

export default {
  components: {
    TrafficLights
  },
  props: [ 'items' ],
  data () {
    return {
      infoSVG: infoSVG,
      pencilSVG: pencilSVG,
      toggle: false,
      headings: [
        'TILLGÅNG',
        '', // To give room for traffic lights
        'AVGIFT (%)',
        'UTVECKLING (%)',
        'VÄRDE (SEK)',
        // '' // To give room for info-img
      ],
    }
  },
  methods: {
    checkIfNA (fee) {
      if(fee === 'N/A') {
        return 'table--NA'
      }
    },
    checkDev (value) {
      let operator = value.charAt(0)

      if(operator === '+') {
        return 'table--dev-plus'
      } else if (operator === '-') {
        return 'table--dev-minus'
      } else if (operator === '') {
        return 'table--NA'
      }
    }
  },
  computed: {
    toggleItems() {
      if(this.toggle) {
        return this.items.filter(item => item.worth !== '');
      }

      return this.items;
    },
    sum() {
      let sum = 0, number = 0, loan = 0

      for(let i = 0; i < this.items.length; i++) {
        if(this.items[i].asset === 'Lån'){
          loan = parseFloat(this.items[i].worth.replace(/\s/g,''));
        }

        if(this.items[i].asset != 'Lån'){
          number = parseFloat(this.items[i].worth.replace(/\s/g,''));
        }

        if(!isNaN(number)) {
          sum += number;
          sum -= loan;
        }
      }

      return sum.toLocaleString("sv-SV")
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  padding: 0; // Overrides card padding
  border-collapse: collapse;
  font-family: "Roboto", sans-serif;
  overflow-x: auto;
  border-radius: 10px;

  &__container {
    border-collapse: collapse;
    width: 100%;

    tr:not(:first-of-type):not(:last-of-type) {
      border-bottom: 1px solid #929292;
    }

    tr:nth-of-type(2) {
      td:first-of-type {
        border-top-left-radius: $borderRadius;
      }

      td:last-of-type {
        border-top-right-radius: $borderRadius;
      }
    }
  }

  &__heading {
    background-color: white;
    color: #585858;
    font-size: .75rem;
  }

  &__heading-text {
    padding: 0 0 .5rem 1rem;
    text-align: left;
  }

  &__cell {
    padding: 1rem;
    min-width: 90px;

    &-text {
      font-size: 1rem;
      border-bottom: 1px solid $light;
      transition: all .3s;

      &-editable {
        color: $green;
      }
    }

    &-link {
      text-decoration: none;
      display: flex;
      align-items: center;

      span {
        transition: all .3s;
      }

      &__icon {
        &-img {
          height: 1rem;
          width: 1rem;
          margin-right: .5rem;
          filter: invert(30%) sepia(94%) saturate(397%) hue-rotate(110deg) brightness(94%) contrast(91%);
        }
      }

      &:hover {
        .table__cell-text {
          border-bottom: 1px solid $green;
        }
      }
    }
  }

  &__info-img {
    height: 1.75rem;
  }

  &__traffic-lights {
    float: right;
  }

  &__sum {
    background-color: $gray;
    color: $light;
  }

  // Modifiers
  &--light {
    background-color: $light;
  }

  &--NA {
    color: #BCBCBC;
    font-weight: 100 !important;
  }

  &--dev-plus {
    color: $lightGreen;
  }

  &--dev-minus {
    color: $red;
  }
}

.switch-container {
  font-size: .75rem;
  float: right;
  margin-bottom: 10px;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin-left: 10px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $light;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 32px;
  width: 32px;
  left: 1px;
  bottom: 1px;
  background-color: $green;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: rgb(190, 190, 190);
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
